import { createAction } from '@reduxjs/toolkit';
const prefix = 'search';
export const searchActions = {
    params: {
        update: createAction(`${prefix}/params/update`),
    },
    savedSearch: {
        apply: createAction(`${prefix}/savedSearch/apply`),
        close: createAction(`${prefix}/savedSearch/close`),
    },
};
